import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { similarityV2TopTitle } from '@/domains/productDiscovery/ProductPage/b2b/components/Recommendation/translations';
import { Recommendation } from '@/domains/productDiscovery/ProductPage/b2c/components/Recommendation/Recommendation';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useRecoEngine } from '@/domains/productDiscovery/Recommendation/hooks/useRecoEngine/useRecoEngine';

export const useSimilarityPlaylist = () => {
  const similarity = useRecoEngine('similarity');

  const isSimilarityAvailable = !!useSelector(similarity.placeHolderSelector);

  return {
    similarity,
    isSimilarityAvailable,
  };
};

const SimilarityPlaylist = memo(() => {
  const { similarity } = useSimilarityPlaylist();
  const [withSideArrowsAB] = useBooleanFlags([
    StringAbTests.PLAYLIST_WITH_ARROWS_AT_SIDES,
  ]);

  return (
    <Recommendation
      titleLabel={similarityV2TopTitle}
      withProductCardsLight
      placeHolderSelector={similarity.placeHolderSelector}
      recommendationSelector={similarity.recommendationSelector}
      dataTestId="top-product-recommendations"
      blockClicked="promoted products"
      position={2}
      displayDeliveryLabel
      withSideArrows={withSideArrowsAB}
    />
  );
});

SimilarityPlaylist.displayName = 'SimilarityPlaylist';

export default SimilarityPlaylist;
